var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form-item-wrapper', {
    attrs: {
      "designer": _vm.designer,
      "field": _vm.field,
      "rules": _vm.rules,
      "design-state": _vm.designState,
      "parent-widget": _vm.parentWidget,
      "parent-list": _vm.parentList,
      "index-of-parent-list": _vm.indexOfParentList,
      "sub-form-row-index": _vm.subFormRowIndex,
      "sub-form-col-index": _vm.subFormColIndex,
      "sub-form-row-id": _vm.subFormRowId
    }
  }, [_c('el-upload', {
    ref: "fieldEditor",
    staticClass: "dynamicPseudoAfter",
    class: {
      'hideUploadDiv': _vm.uploadBtnHidden || _vm.isReadMode
    },
    style: (_vm.styleVariables),
    attrs: {
      "disabled": _vm.field.options.disabled || _vm.isReadMode,
      "action": _vm.realUploadURL,
      "headers": _vm.uploadHeaders,
      "data": _vm.uploadData,
      "with-credentials": _vm.field.options.withCredentials,
      "multiple": _vm.field.options.multipleSelect,
      "file-list": _vm.fileList,
      "show-file-list": _vm.field.options.showFileList,
      "limit": _vm.field.options.limit,
      "on-exceed": _vm.handleFileExceed,
      "before-upload": _vm.beforeFileUpload,
      "on-success": _vm.handleFileUpload,
      "on-error": _vm.handleUploadError
    },
    scopedSlots: _vm._u([{
      key: "file",
      fn: function(ref) {
        var file = ref.file;

        return [_c('div', {
          staticClass: "upload-file-list"
        }, [_c('span', {
          staticClass: "upload-file-name",
          attrs: {
            "title": file.name
          }
        }, [_vm._v(_vm._s(file.name))]), _vm._v(" "), _c('a', {
          attrs: {
            "href": file.url,
            "download": "",
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "el-icon-download file-action",
          attrs: {
            "title": _vm.i18nt('render.hint.downloadFile')
          }
        })]), _vm._v(" "), (!_vm.field.options.disabled && !_vm.isReadMode) ? _c('i', {
          staticClass: "el-icon-delete file-action",
          attrs: {
            "title": _vm.i18nt('render.hint.removeFile')
          },
          on: {
            "click": function($event) {
              return _vm.removeUploadFile(file.name, file.url, file.uid)
            }
          }
        }) : _vm._e()])]
      }
    }])
  }, [(!!_vm.field.options.uploadTip) ? _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v(_vm._s(_vm.field.options.uploadTip))]) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon",
    attrs: {
      "slot": "default"
    },
    slot: "default"
  })])], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c16553d","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form-designer/form-widget/field-widget/file-upload-widget.vue
// module id = null
// module chunks = 